import { FC } from 'react'
import { FlexboxGrid } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'

import BrowseProducts from '../BrowseProducts'
import MobileBlockerIcon from '../Icons/BuyerPortal/MobileBlockerIcon'

const BuyerMobileBlocker: FC = () => {
  const { t } = useTranslation('buyerProfile')

  return (
    <FlexboxGrid
      justify="center"
      className="margin-top-spacer-quadruple"
    >
      <FlexboxGrid.Item>
        <div className="margin-top-spacer-double">
          <MobileBlockerIcon />
        </div>
        <h4 className="margin-top-spacer-double">
          {t('blocker:More on desktop')}
        </h4>
        <p className="margin-top-spacer">
          {t('blocker:The page you tried to access is currently only available on the computer version')}
          .
        </p>
        <BrowseProducts />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  )
}

export default BuyerMobileBlocker
